import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CalcPipeline extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var calcPipeline = this;
		setTimeout(function(){
			calcPipeline.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var calcPipeline = this;
		
		var mainStyles = ElementUtil.create({
			tag: 'style',
			innerHTML: `
				.pipeline-main {
					height: 100%; 				
					padding: 40px;
				}			
			
				.pipeline-stage {
					width: 50%; 
					height: 150px; 
					border: 1px solid #9f9f9f; 
					box-shadow: 1px 11px 19px 0px #2d4956;					
					border-radius: 5px;
					margin-left: auto; 
					margin-right: auto;
					color: black;
				}
			
				.pipeline-line {
					width: 3px; 
					height: 100px; 
					background: #9f9f9f;
					background: linear-gradient(343deg, rgba(190,224,199,1) 0%, rgba(157,208,171,1) 42%, rgba(206,247,217,1) 100%);
					border: 1px solid #9f9f9f;
					margin-left: auto; 
					margin-right: auto;					
				}
			
				.pipeline-arrow {
					width: 0; 
					height: 0; 
					border-left: 20px solid transparent; 
					border-right: 20px solid transparent; 
					border-top: 20px solid grey;
					margin-left: auto; 
					margin-right: auto;
				}
			
				.pipeline-enabled {
					background: #bbfbbb; 
					background: linear-gradient(343deg, rgba(190, 224, 199, 1) 0%, rgb(56 123 74) 42%, rgba(206, 247, 217, 1) 100%);
				}
			
				.pipeline-disabled {
					background: lightgrey; 
				}
			
             `
		});
		calcPipeline.append(mainStyles);
		
		var enabledText = '<i class="fas fa-check" style="color: green;"></i> Enabled';
		var disabledText = '<i class="fas fa-window-close" style="color: red;"></i> Disabled';
		
		var loadMask = window.DL.MessageUtil.fullPageLoadMask();			
		DataManagementService.getCalcPreferences().getCalcPreferences().then(function(preferenceFull) {
			DataManagementService.getCalcPreferences().getCalcPreferenceStage().then(function(data){
				loadMask.remove();

				var stageViewElements = [];
				var count=0;
				data.forEach(function(stage){
					count++;

					var enableClass = 'pipeline-enabled';

					var statusMessage = enabledText;
					if (stage.optional) {
						if (stage.calcStageKey === 'ODOMETER-ADJ') {
							if (!stage.calcPreference.odometerAdjustmentEnabled) {
								statusMessage = disabledText;
								enableClass = 'pipeline-disabled';
							}
						} else if (stage.calcStageKey === 'IDLE') {
							if (!stage.calcPreference.calcIdleEnable) {
								statusMessage = disabledText;
								enableClass = 'pipeline-disabled';
							}
						} else if (stage.calcStageKey === 'ODOMETER-EST') {
							if (!stage.calcPreference.odometerEstimateEnabled) {
								statusMessage = disabledText;
								enableClass = 'pipeline-disabled';
							}
						} else 	if (stage.calcStageKey === 'TANK_LEVELS') {
							if (!stage.calcPreference.estimateTankCapacityEnabled) {
								statusMessage = disabledText;
								enableClass = 'pipeline-disabled';
							}
						} else 	if (stage.calcStageKey === 'TRIP_DETAIL') {
							if (!stage.calcPreference.calcOorDetailEnabled) {
								statusMessage = disabledText;
								enableClass = 'pipeline-disabled';
							}
						} else 	if (stage.calcStageKey === 'UNIT_SUMMARY') {
							if (!stage.calcPreference.calcSummariesEnabled) {
								statusMessage = disabledText;
								enableClass = 'pipeline-disabled';
							}
						}
					}

					stageViewElements.push({
						tag: 'div',
						itemid: 'stage-' + stage.calcStageKey,
						'class': 'pipeline-stage ' + enableClass,
						children: [
							{
								tag: 'h2',
								style: 'text-align: center',
								innerHTML: stage.calcStageName
							},
							{
								tag: 'div',
								style: 'padding: 10px; color: #4b4b4b',
								innerHTML: stage.description
							},
							{
								tag: 'dl-toolbar',
								children: [
									{
										tag: 'dl-action-button',

										theme: 'primary',
										'class': 'spacer-toolbar-item',
										permissions: ['CALC_PREFERENCES:WRITE'],
										children: [
											ElementUtil.makeIcon('vaadin:cog', ' Options')
										],
										listeners: {
											click: function () {
												actionEditOptions(stage, preferenceFull);
											}
										}
									},
									{
										tag: 'div',
										itemid: 'stage-message-' + stage.calcStageKey,
										style: 'float: right; margin-right: 10px;',
										innerHTML: statusMessage										
									}
								]
							}
						]
					});

					if (count !== data.length) {
						stageViewElements.push({
							tag: 'div',
							'class': 'pipeline-line'
						});
						stageViewElements.push({
							tag: 'div',
							'class': 'pipeline-arrow'
						});
					} else {
						stageViewElements.push({
							tag: 'div',
							style: 'width: 20px; height: 20px;margin-left: auto;	margin-right: auto;'
						});
					}
				});

				calcPipeline.mainContainer = ElementUtil.create({
					tag: 'div',
					slot: 'primary',
					'class': 'pipeline-main',
					children: stageViewElements
				});

				var flexLayout = ElementUtil.create({
					tag: 'dl-flex-layout',
					children: [				
						calcPipeline.mainContainer
					]
				});		

				calcPipeline.append(flexLayout);
			});
		});

		
		var actionEditOptions = function(stage, preferenceFull) {
			
			if (stage.calcStageKey === 'ODOMETER-ADJ') {
				editOdometerAdjWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'ROUTING') {
				editRoutingWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'IDLE') {
				editIdleWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'ODOMETER-EST') {
				editOdometerEstWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'TANK_LEVELS') {
				editTankWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'TRIP_DETAIL') {
				editTripDetailWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'UNIT_SUMMARY') {
				editUnitSummaryWindow(stage, preferenceFull);
			} else if (stage.calcStageKey === 'TRIP') {
				editTripWindow(stage, preferenceFull);
			}			
			
		};
		
		var editRoutingWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-number-field',										
											name: 'maxDayBetweenPoints',
											label: 'Max Days Between Points',											
											required: true,										
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'minEmpgTolerence',
											label: 'Min Engine MPG Tolerence',											
											required: true,										
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'maxEmpgTolerence',
											label: 'Max Engine MPG Tolerence',											
											required: true,											
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-checkbox',
											name: 'crowFlyAdjustmentEnabled',
											label: 'CrowFly Adjustement Enabled'																	
										},	
										{
											tag: 'vaadin-number-field',										
											name: 'crowFlyToleranceAmount',
											label: 'CrowFly Tolerance Percentage',											
											required: true,											
											min: 0,
											max: 1000
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.routingPreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	
																	//update stage
																	
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};
		
		var editOdometerAdjWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [	
										{
											tag: 'vaadin-checkbox',
											name: 'odometerAdjustmentEnabled',
											label: 'Odometer Adjustement Enabled'																	
										},	
										{
											tag: 'vaadin-number-field',										
											name: 'odometerTolerenceMin',
											label: 'Odometer Tolerence Min',											
											required: true,										
											min: -1000,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'odometerTolerenceMax',
											label: 'Odometer Tolerence Max',											
											required: true,										
											min: -1000,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'maxDaysBetweenPoints',
											label: 'Max Days Between Points',											
											required: true,											
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-checkbox',
											name: 'resetOdometerOnNegative',
											label: 'Reset Odometer On Negative'																	
										},											
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.odometerPreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	updateStageState(stage, data.odometerAdjustmentEnabled);
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};		
			
		var editIdleWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 345,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [			
										{
											tag: 'vaadin-checkbox',
											name: 'calcIdleEnable',
											label: 'Idle Calculation Enabled'																	
										},
										{
											tag: 'vaadin-checkbox',
											name: 'calcIdleFuelBurnOnlyEnable',
											label: 'Fuel Burn Only Enabled'																	
										},
										{
											tag: 'vaadin-number-field',										
											name: 'fuelBurnedPerHour',
											label: 'Fuel Burn Per Hour',											
											required: true,										
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'milePerHourThreshold',
											label: 'MPH Threshold',											
											required: true,										
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'averageIdleMinutesPerHour',
											label: 'Average Idle MPH',											
											required: true,											
											min: 0,
											max: 60
										},										
										{
											tag: 'vaadin-number-field',										
											name: 'averageDrivingSpeed',
											label: 'Average Driving Speed',											
											required: true,											
											min: 0,
											max: 1000
										},										
										{
											tag: 'vaadin-number-field',										
											name: 'averageMPG',
											label: 'Average MPG',											
											required: true,											
											min: 0,
											max: 1000
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.idlePreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																																		
																	updateStageState(stage, data.calcIdleEnable);
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};	
		
		var editOdometerEstWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [	
										{
											tag: 'vaadin-checkbox',
											name: 'odometerEstimateEnabled',
											label: 'Odometer Estimate Enabled'																	
										},											
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.odometerEstimatePreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	
																	updateStageState(stage, data.odometerEstimateEnabled);																	
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};	
		
		var editTankWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 400,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [	
										{
											tag: 'vaadin-checkbox',
											name: 'estimateTankCapacityEnabled',
											label: 'Estimated Tank Enabled'																	
										},
										{
											tag: 'vaadin-number-field',										
											name: 'maxTimeBetweenReadings',
											label: 'Max Time Between Points',											
											required: true,										
											min: 0,
											max: 20000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'fuelMatchTime',
											label: 'Fuel Match Time',											
											required: true,										
											min: 0,
											max: 20000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'fuelMatchDistance',
											label: 'Fuel Match Distance',											
											required: true,											
											min: 0,
											max: 10000
										},										
										{
											tag: 'vaadin-number-field',										
											name: 'gpsMatchTime',
											label: 'GPS Match Time',											
											required: true,											
											min: 0,
											max: 10000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'fuelPurchaseTrigger',
											label: 'Fuel Purchase Trigger',											
											required: true,											
											min: -999,
											max: 10000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'fuelDeltaLossTrigger',
											label: 'Fuel Delta Loss Trigger',											
											required: true,											
											min: 0,
											max: 10000
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.tankLevelPreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	
																	updateStageState(stage, data.estimateTankCapacityEnabled);
																																		
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};
		
		var editTripDetailWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [	
										{
											tag: 'vaadin-checkbox',
											name: 'calcOorDetailEnabled',
											label: 'Calculate Details'																	
										},	
										{
											tag: 'vaadin-number-field',										
											name: 'tripOorTolerenceMiles',
											label: 'Out of Route Tolerence Miles',											
											required: true,										
											min: 0,
											max: 1000
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.tripDetailPreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	
																	updateStageState(stage, data.calcOorDetailEnabled);																	
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};		
		
		var editUnitSummaryWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [		
										{
											tag: 'vaadin-checkbox',
											name: 'calcSummariesEnabled',
											label: 'Calculate Summaries'																	
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.summaryPreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	
																	updateStageState(stage, data.calcSummariesEnabled);																	
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};		
		
		var editTripWindow = function(stage, preferenceFull) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit ' + stage.calcStageName,
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-number-field',										
											name: 'tripGpsDistance',
											label: 'GPS Distance',											
											required: true,										
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'tripGpsTime',
											label: 'GPS Time',											
											required: true,										
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'dataTypeCB',
											name: 'stopMatchingStrategy',
											label: 'Matching Strategy',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TripStopMatchingStrategy').then(function (data) {																										
													combo.items = data;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {																	
																	preferenceFull.tripPreference = data;
																	stage.calcPreference = data;
																	return DataManagementService.getCalcPreferences().updateCalcPreferences(preferenceFull);
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Preferences', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																																
																	
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						formPanel.load(stage.calcPreference);						
						
					}
				}
			});			
			
		};
		
		
		var updateStageState = function(stage, enable) {
			
			//update stage
			var stageDiv = ElementUtil.query(calcPipeline.mainContainer, 'stage-' + stage.calcStageKey);
			var stageMessage = ElementUtil.query(calcPipeline.mainContainer, 'stage-message-' + stage.calcStageKey);

			if (enable) {
				stageDiv.classList.remove('pipeline-disabled');
				stageDiv.classList.add('pipeline-enabled');
				stageMessage.innerHTML = enabledText;
			} else {
				stageDiv.classList.remove('pipeline-enabled');
				stageDiv.classList.add('pipeline-disabled');
				stageMessage.innerHTML = disabledText;
			}
																	
		};	
		
	}
	
}
customElements.define('dl-calc-pipeline', CalcPipeline);
